import React from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'
import moment from 'moment'
import 'moment/locale/sq'
import 'moment/locale/en-gb'
import { PercentageIndicator } from '@vfgroup-oneplatform/foundation/Components'
import { Colors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import VfText from '../VfText'

import styles from './ProgressBar.Styles'

const LANGUAGES = {
  al: 'sq',
  en: 'en-gb',
}

function ProgressBar(props) {
  const {
    startDate,
    endDate,
    backgroundColor,
    foregroundColor,
    usedLabel,
    totalLabel,
    dateFormat,
    visibleDateFormat,
    isLoading,
    isContentLoading,
    loadingBackgroundColor,
    loadingForegroundColor,
    language,
  } = props

  const theme = useTheme()

  moment.locale(LANGUAGES[language])

  let available,
    total,
    percent = 0,
    animate = false
  if (startDate && endDate) {
    const start = moment(startDate, dateFormat)
    const end = moment(endDate, dateFormat)
    available = moment().diff(start, 'days')
    total = end.diff(start, 'days')
    if (!isNaN(available) && !isNaN(total)) {
      percent = ((total - available) / total) * 100
      animate = true
    }
  }

  return (
    <View style={styles.container}>
      <View style={styles.datesContainer}>
        <VfText
          size="body"
          weight="regular"
          align="left"
          i18nKey={moment(startDate, dateFormat).format(visibleDateFormat)}
          isLoading={isLoading}
          style={styles.text}
          loadingBackgroundColor={loadingBackgroundColor}
          loadingForegroundColor={loadingForegroundColor}
          color={theme.colors.textColor}
        />
        <VfText
          size="body"
          weight="regular"
          align="right"
          i18nKey={moment(endDate, dateFormat).format(visibleDateFormat)}
          isLoading={isLoading}
          style={styles.text}
          loadingBackgroundColor={loadingBackgroundColor}
          loadingForegroundColor={loadingForegroundColor}
          color={theme.colors.textColor}
        />
      </View>
      <PercentageIndicator
        value={percent}
        color={Colors.ocean}
        fillColor={Colors.tangerine}
        containerStyle={styles.percentageIndicator}
        animate={animate}
      />
      <View style={styles.legendContainer}>
        <View
          style={[
            { borderLeftColor: backgroundColor },
            styles.usedLabelContainer,
          ]}>
          <VfText
            size="footnote"
            weight="regular"
            align="left"
            i18nKey={usedLabel}
            isLoading={isContentLoading}
            style={styles.text}
            loadingBackgroundColor={loadingBackgroundColor}
            loadingForegroundColor={loadingForegroundColor}
            color={theme.colors.textColor}
          />
        </View>

        <View
          style={[
            { borderLeftColor: foregroundColor },
            styles.totalLabelContainer,
          ]}>
          <VfText
            size="footnote"
            weight="regular"
            align="right"
            i18nKey={totalLabel}
            isLoading={isContentLoading}
            style={styles.text}
            loadingBackgroundColor={loadingBackgroundColor}
            loadingForegroundColor={loadingForegroundColor}
            color={theme.colors.textColor}
          />
        </View>
      </View>
    </View>
  )
}

ProgressBar.defaultProps = {
  loadingBackgroundColor: '#f3f3f3',
  loadingForegroundColor: '#ecebeb',
  language: 'en',
}

ProgressBar.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  backgroundColor: PropTypes.string,
  foregroundColor: PropTypes.string,
  usedLabel: PropTypes.string,
  totalLabel: PropTypes.string,
  dateFormat: PropTypes.string,
  visibleDateFormat: PropTypes.string,
  isLoading: PropTypes.bool,
  isContentLoading: PropTypes.bool,
  loadingBackgroundColor: PropTypes.string,
  loadingForegroundColor: PropTypes.string,
  language: PropTypes.string,
}

export default ProgressBar
